import * as styles from "@/pages/InvoiceDetailPage.styles";
import * as shared from "@/styles/shared";
import type { InvoiceNeighborCardProps } from "@/types/invoices";
import { formatAmount, formatDate } from "@shared/utils";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const InvoiceNeighborCard = ({ neighbor, direction }: InvoiceNeighborCardProps) => {
  const { t } = useTranslation("invoiceDetail");

  if (!neighbor) {
    return <div className={styles.neighborEmpty}>{t(direction)}</div>;
  }

  const Arrow = direction === "previousInvoice" ? ArrowLeft : ArrowRight;

  return (
    <Link to={`/invoices/${neighbor.id}`} className={styles.neighborLink}>
      <div>
        <div className={styles.neighborLabel}>{t(direction)}</div>
        <div className={shared.titleSmSemibold}>{formatDate(neighbor.invoiceDate)}</div>
      </div>
      <div className={styles.neighborAmount}>
        <span className={shared.titleSmSemibold}>{formatAmount(neighbor.amount)}</span>
        <Arrow className={styles.copyIcon} />
      </div>
    </Link>
  );
};

export { InvoiceNeighborCard, type InvoiceNeighborCardProps };
